import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        this.cookieBar = this.element.querySelector('.cookie-bar');
        this.cookieFloater = this.element.querySelector('.cookie-floater');
        this.cookieClose = this.element.querySelector('.cookie-close');

        this.cookieFloater.addEventListener('click', () => this.openCookieBar());
        this.cookieClose.addEventListener('click', () => this.closeCookieBar());

        for (const cookieSubmit of this.cookieBar.querySelectorAll('.cookie-submit')) {
            cookieSubmit.addEventListener('click', () => this.saveCookies(cookieSubmit));
        }
    }

    saveCookies(cookieSubmit) {
        const functional = this.cookieBar.querySelector('input[name=cookie_functional]').checked;
        const analytics = this.cookieBar.querySelector('input[name=cookie_analytics]').checked;
        const acceptAll = cookieSubmit.classList.contains('accept-all');

        const d = new Date();
        d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
        const expires = `expires=${d.toGMTString()}`;

        document.cookie = `consents_essentials=1;${expires};path=/`;

        if (acceptAll) {
            document.cookie = `consents_functional=1;${expires};path=/`;
            document.cookie = `consents_analytics=1;${expires};path=/`;
        } else {
            document.cookie = `consents_functional=${functional ? '1' : '0'};${expires};path=/`;
            document.cookie = `consents_analytics=${analytics ? '1' : '0'};${expires};path=/`;
        }

        this.animateOut(this.cookieBar, () => {
        }, () => {
            this.cookieBar.classList.add('d-none');
        });

        this.animateIn(this.cookieFloater, () => {
            this.cookieFloater.classList.remove('d-none');
        }, () => {
        });

        window.location.reload();
    }

    openCookieBar() {
        this.cookieBar.classList.remove('d-none');
        this.cookieFloater.classList.add('d-none');

        this.animateOut(this.cookieFloater, () => {
        }, () => {
            this.cookieFloater.classList.add('d-none');
        });

        this.animateIn(this.cookieBar, () => {
            this.cookieBar.classList.remove('d-none');
        }, () => {
        });
    }

    closeCookieBar() {
        this.animateOut(this.cookieBar, () => {
        }, () => {
            this.cookieBar.classList.add('d-none');
        });

        this.animateIn(this.cookieFloater, () => {
            this.cookieFloater.classList.remove('d-none');
        }, () => {
        });
    }

    animateIn(target, before, callback) {
        let op = 0.1;
        target.style.opacity = op;
        before();
        const timer = setInterval(function () {
            if (op >= 1) {
                clearInterval(timer);
                callback();
            }
            target.style.opacity = op;
            target.style.filter = `alpha(opacity=${op * 100})`;
            op += op * 0.1;
        }, 5);
    }

    animateOut(target, before, callback) {
        let op = 1;
        target.style.opacity = op;
        before();
        const timer = setInterval(function () {
            if (op <= 0.1) {
                clearInterval(timer);
                callback();
            }
            target.style.opacity = op;
            target.style.filter = `alpha(opacity=${op * 100})`;
            op -= op * 0.1;
        }, 5);
    }
}
